import { useEffect } from 'react';

/**
 * LegacyRedirect — Immediate JavaScript redirect for legacy URLs
 * with a genuine current equivalent.
 * 
 * Uses window.location.replace() for zero-delay navigation.
 * Google recognizes JavaScript redirects per their JS SEO documentation.
 * window.location.replace() does not create a history entry (back-button safe).
 */
export default function LegacyRedirect({ to }) {
  useEffect(() => {
    // Immediate redirect — no rendering visible to user
    window.location.replace(to);
  }, [to]);

  // Fallback for non-JS crawlers (unlikely with Googlebot, but safe)
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <p>Redirecting to <a href={to}>{to}</a>...</p>
    </div>
  );
}
